import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, Tooltip } from "recharts";
import { DIMENSIONS, rung } from "../lib/bopta";

export const BoptaRadar = ({ series, height = 300 }) => {
  const data = DIMENSIONS.map((d) => ({ dim: d.name, ...Object.fromEntries(series.map((s) => [s.name, s.dims?.[d.k] ?? 0])) }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={data} outerRadius="60%" margin={{ left: 40, right: 40 }}>
        <PolarGrid stroke="#E4E4DE" />
        <PolarAngleAxis dataKey="dim" tick={{ fontSize: 12, fill: "#111614" }} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
        {series.map((s) => <Radar key={s.name} name={s.name} dataKey={s.name} stroke={s.color} fill={s.color} fillOpacity={0.2} strokeWidth={2} />)}
        <Tooltip />
        {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
      </RadarChart>
    </ResponsiveContainer>
  );
};

const horizonLabel = (v) => DIMENSIONS[0].horizon.anchors.reduce((p, c) => (Math.abs(c.v - v) < Math.abs(p.v - v) ? c : p)).t;

export const DimBars = ({ dims, lowest, horizon, bottlenecks = [] }) => (
  <div className="space-y-4">
    {DIMENSIONS.map((d) => (
      <div key={d.k} data-testid={`dim-bar-${d.k}`}>
        <div className="mb-1 flex justify-between text-sm">
          <span className="flex items-center gap-2 font-medium">
            <span className="chip" style={{ background: d.color }}>{d.k}</span>{d.name}
            <span className="text-xs font-normal muted" data-testid={`dim-level-${d.k}`}>· L{rung(dims[d.k]).n} {rung(dims[d.k]).translation}</span>
            {lowest === d.k && <span className="rounded-full bg-[#FDEFE6] px-2 py-0.5 text-[10px] font-bold uppercase text-[var(--orange)]">Start here</span>}
            {bottlenecks.includes(d.k) && <span className="rounded-full bg-[var(--orange)] px-2 py-0.5 text-[10px] font-bold uppercase text-white" data-testid={`bottleneck-${d.k}`}>Bottleneck</span>}
          </span>
          <b>{Math.round(dims[d.k])}</b>
        </div>
        <div className="h-2 rounded-full bg-[#EFEFEA]"><div className="h-2 rounded-full" style={{ width: `${dims[d.k]}%`, background: d.color }} /></div>
        {horizon && <p className="mt-1 text-xs muted" data-testid={`horizon-${d.k}`}>Planning horizon: {horizonLabel(horizon[d.k])}</p>}
      </div>
    ))}
  </div>
);
